export function Insha() {
  return (
    <div className="flex-1 flex flex-col justify-center h-full w-full  gap-8  ">
      <div className="flex flex-col justify-center items-center  text-black cursor-pointer mt:10">
        <h1 className="text-8xl font-bold ">Hi,</h1>
        <h2 className="text-5xl font-thin ">I am Salman</h2>
      </div>

      <div className="flex w-full justify-center items-center flex-col gap-2">
        <p className="text-lg">Human += Engineer</p>
        <p className="text-xs text-gray-600">
          7+ Years of Experience as Software Engineer
        </p>
        <p className="text-xs text-gray-600">
          <b>Email:</b> hello@salmanjaved.com
        </p>
        <p className="text-xs text-gray-400">🇩🇪 Berlin, Germany </p>
      </div>
    </div>
  );
}
